import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BookingService } from '../../../services/Booking/booking.service';
import { f } from "../../../../../node_modules/@angular/material/icon-module.d-COXCrhrh";
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MomentFormatPipe } from "../../../moment.pipe";
import { YesNoPipe } from "../../../pipes/yes-no.pipe";
import { AuthService } from '../../../services/Auth/auth.service';

@Component({
    selector: 'app-dashboard-booking-overlay',
    imports: [
        CommonModule,
        RouterModule,
        MatIconModule,
        MatSnackBarModule,
        MomentFormatPipe,
        YesNoPipe
    ],
    templateUrl: './dashboard-booking-overlay.component.html',
    styleUrl: './dashboard-booking-overlay.component.scss'
})
export class DashboardBookingOverlayComponent {

    constructor(
        public bookingService: BookingService,
        public authService: AuthService,
        private snackBar: MatSnackBar,
    ) {

    }

    ngOnInit() {
        this.bookingService.isDashBookingOpen$.subscribe(isOpen => {
            if (isOpen) {
                if (this.bookingService.dashBooking?.userID) {

                    this.authService.getProfileByUserId(this.bookingService.dashBooking?.userID).subscribe(data => {
                        if (this.bookingService.dashBooking && data) {
                            this.bookingService.dashBooking.profile = data
                        }
                    })
                }

                document.body.style.overflow = 'hidden';
            }
            else {
                document.body.style.overflow = '';
            }
        })
    }

    close() {
        this.bookingService.dashClose()
    }

    onApproveBooking() {
        if(this.bookingService.dashBooking) {
            this.bookingService.onApproveBooking(this.bookingService.dashBooking).then(() => {
                this.close()
                //This Booking Request has been moved to Approved Bookings
                this.snackBar.open('This Booking Request has been moved to Approved Bookings', '+', { duration: 5000 });
            }) 
        }
    }
    
    onDeniedBooking() {
        if(this.bookingService.dashBooking) {
            this.bookingService.onDenyBooking(this.bookingService.dashBooking).then(() => {
                this.close()

                //This Booking Request has been moved to Approved Bookings
                this.snackBar.open('This Booking Request has been denied. Please have the sales rep follow up with the theater owner', '+', { duration: 5000 });
            }) 
        }
    }
}
